import { NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignatureFieldComponent } from './signature-field.component';
import { SignaturePadModule } from 'angular2-signaturepad';

@NgModule({
    imports: [
        CommonModule,
        SignaturePadModule,
    ],
    declarations: [SignatureFieldComponent],
    exports: [SignatureFieldComponent],
    schemas: [ NO_ERRORS_SCHEMA ]
})
export class SignatureFieldModule { }
